import React from 'react'
import { Control, Controller, RegisterOptions } from 'react-hook-form'

interface TextInputProps {
  type?: string
  placeholder?: string
  name: string
  label?: string
  defaultValue?: string
  error?: any
  control?: Control<any>
  required?: boolean | string
  infoMessage?: JSX.Element | string
  disabled?: boolean
  customStyles?: React.CSSProperties
  rules?: RegisterOptions
}

const TextInput = (props: TextInputProps) => {
  const {
    type = 'text',
    name,
    label,
    control,
    required,
    placeholder,
    disabled,
    infoMessage,
    customStyles,
    rules,
  } = props

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: disabled ? false : required ? 'This field is required' : false,
        ...rules,
      }}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
        <div className="flex flex-1 flex-col">
          {label && (
            <label
              className={`block ${required ? 'required' : ''} ${
                error ? 'text-primary' : 'text-detailPrimary'
              } text-sm font-bold font-Karla mb-2`}
              htmlFor={name}>
              {label}
            </label>
          )}
          <input
            type={type}
            id={name}
            className={`react-select__control border-2 dark:bg-slate-500  rounded-lg ${
              error ? 'border-[#F00]' : 'border-none'
            }`}
            style={{
              minWidth: 185,
              height: 32,
              minHeight: 32,
              fontWeight: 'bold',
              fontSize: 12,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              padding: '0 8px',
              ...customStyles,
            }}
            placeholder={placeholder}
            disabled={disabled}
            ref={ref}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
          />
          {error && !disabled && (
            <span className="font-medium text-xs text-[#F00]">{error.message}</span>
          )}
          {infoMessage && <div className="mt-1 text-xs ">{infoMessage}</div>}
        </div>
      )}
    />
  )
}

export default TextInput
